import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Main, Thumbs, Image } from './styles';
import { ThumbsPosition } from './types';
import { Typography } from '@mui/material';

const DEFAULT_PROPS = {
  initialImage: 0,
  thumbsPosition: ThumbsPosition.Left,
};

export const Props = {
  initialImage: PropTypes.number,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
  ),
  thumbsPosition: PropTypes.oneOf([ThumbsPosition.Left, ThumbsPosition.Bottom]),
};

export default function ImageSlider({ images, initialImage, thumbsPosition }) {
  const [activeImage, setActiveImage] = useState(initialImage);

  const handleImageClick = (index) => {
    setActiveImage(index);
  };

  const thumbs = images.map((image, index) => (
    <Image
      isActive={index === activeImage}
      key={image.id}
      src={image.src}
      alt={image.alt}
      onClick={() => handleImageClick(index)}
    />
  ));

  return (
    <Container position={thumbsPosition}>
      <Main position={thumbsPosition}>
        <Image
          isMain
          src={images[activeImage].src}
          alt={images[activeImage].alt}
          onClick={() => {}}
        />

        <Typography align="center" component="p" style={{ fontSize: 12 }}>
          {images[activeImage].alt}
        </Typography>
      </Main>
      <Thumbs position={thumbsPosition}>{thumbs}</Thumbs>
    </Container>
  );
}

ImageSlider.propTypes = Props;
ImageSlider.defaultProps = DEFAULT_PROPS;
